// ============================================
// GO2 DIGITAL - Slovenska vsebina
// ============================================

export const navLinks = [
  { label: 'O NAS', href: '/o-nas/' },
  { label: 'STORITVE', href: '/storitve/' },
  { label: 'PROJEKTI', href: '/projekti/' },
];

// HERO
export const heroVariations = [
  {
    line1: 'Ne',
    line2: 'Tržimo.',
    accent: 'Gradimo.',
  },
  {
    line1: 'Digitalne',
    line2: 'Platforme.',
    accent: 'Grajene za rezultate.',
  },
  {
    line1: 'Od Nič',
    line2: 'do Prihodkov.',
    accent: 'Mi zgradimo sistem.',
  },
];

export const heroSubheadline = 'go2digital gradi, upravlja in skalira visoko zmogljive digitalne platforme — s pomočjo SEO, partnerskih ekosistemov in umetne inteligence.';

export const heroStats = [
  { value: '500K+', label: 'Organskih obiskov/mesec' },
  { value: '5', label: 'Aktivnih platform' },
  { value: '3', label: 'Trgi' },
];

// KAJ DELAMO
export const whatWeDo = [
  {
    icon: 'Search',
    title: 'SEO & organska rast',
    description: 'Načrtujemo vidnost v iskalnikih na sistemski ravni. Naše platforme se uvrščajo za tisoče ključnih besed in ustvarjajo konstanten organski promet, ki sčasoma narašča.',
  },
  {
    icon: 'Link',
    title: 'Affiliate & monetizacija',
    description: 'Vsaka platforma, ki jo zgradimo, ima vgrajeno monetizacijo. Oblikujemo partnerske ekosisteme, prodajne lijake in modele sodelovanja, ki promet pretvorijo v prihodek.',
  },
  {
    icon: 'Code',
    title: 'Razvoj platform',
    description: 'Gradimo infrastrukturo. Spletne platforme po meri, vsebinski sistemi in skalabilne spletne rešitve, zasnovane za dolgoročno rast — ne kratkoročne kampanje.',
  },
  {
    icon: 'Brain',
    title: 'Integracija umetne inteligence',
    description: 'V naše platforme vgrajujemo AI za avtomatizacijo vsebin, personalizacijo uporabniških izkušenj in razvoj orodij z resnično dodano vrednostjo — kot je naš AI potovalni pomočnik.',
  },
];

// PROJEKTI
export const projects = [
  {
    name: 'go2georgia.com',
    type: 'AI potovalna platforma',
    status: 'V živo',
    year: '2024',
    tagline: 'Načrtovanje potovanj v Gruzijo s pomočjo AI',
    description: 'Celovita potovalna platforma, ki združuje kurirano vsebino o destinacijah z AI načrtovalnikom potovanj. Zgrajena za prevlado v organskem iskanju na področju potovanj v Gruzijo. Monetizirana prek affiliate partnerstev s hoteli, turami in lokalnimi ponudniki.',
    outcomes: [
      'Uvrstitev med top 3 za 200+ ključnih besed o potovanjih v Gruzijo v 8 mesecih',
      'AI načrtovalnik potovanj ustvarja personalizirane itinerarje v sekundah',
      'Affiliate prihodki rastejo 40 % mesec za mesec',
    ],
    tags: ['AI', 'SEO', 'Affiliate', 'Potovanja'],
    link: 'https://go2georgia.com',
  },
  {
    name: 'go2slovenia.com',
    type: 'Avtoritativna potovalna stran',
    status: 'V živo',
    year: '2023',
    tagline: 'Ultimativni vodnik po Sloveniji',
    description: 'Avtoritativna vsebinska platforma, ki pokriva vse, kar popotniki potrebujejo o Sloveniji. Zgrajena kot dolgoročno SEO sredstvo z globoko tematsko pokritostjo, lokalnim znanjem in strateško monetizacijo prek turističnih partnerstev.',
    outcomes: [
      'Vzpostavljena avtoriteta domene v konkurenčni niši potovanj po Sloveniji',
      'Celovita pokritost 50+ destinacij',
      'Prihodki prek hotelskih affiliate programov in partnerstev s turističnimi ponudniki',
    ],
    tags: ['SEO', 'Vsebina', 'Affiliate', 'Potovanja'],
    link: 'https://go2slovenia.com',
  },
  {
    name: 'potovanja.si',
    type: 'Potovalni medij',
    status: 'V živo',
    year: '2022',
    tagline: 'Slovenski potovalni medijski portal',
    description: 'Slovenska potovalna medijska platforma, ki dosega široko občinstvo z vodniki po destinacijah, potovalnimi nasveti in kuriranimi priporočili. Zasnovana kot prometni motor, ki napaja širši ekosistem go2digital.',
    outcomes: [
      'Prevladujoča organska prisotnost v slovenskem potovalnem iskanju',
      'Vsebinski sistem, ki proizvaja visoko uvrščene članke',
      'Medplatformska distribucija prometa po celotnem ekosistemu',
    ],
    tags: ['Medij', 'SEO', 'Vsebina', 'Slovenski trg'],
    link: 'https://potovanja.si',
  },
  {
    name: 'avanture.si',
    type: 'Portal za doživljajska potovanja',
    status: 'V živo',
    year: '2023',
    tagline: 'Doživljajska potovanja, kurirana',
    description: 'Nišni portal, osredotočen na doživljajska in aktivna potovanja v Sloveniji in na Balkanu. Cilja na strastno občinstvo z visokim konverzijskim potencialom za affiliate partnerstva z organizatorji doživetij.',
    outcomes: [
      'Nišna avtoriteta na področju doživljajskih potovanj',
      'Visoko angažirano občinstvo z močnimi konverzijskimi stopnjami',
      'Partnerski kanal z organizatorji doživljajskih tur',
    ],
    tags: ['Niša', 'Doživetja', 'Affiliate', 'Aktivno'],
    link: 'https://avanture.si',
  },
  {
    name: 'go2balkans.com',
    type: 'Regionalna potovalna platforma',
    status: 'V razvoju',
    year: '2025',
    tagline: 'Balkan, odkrit',
    description: 'Naslednja širitev ekosistema go2. Celovita potovalna platforma, ki pokriva celotno balkansko regijo — od Hrvaške do Albanije, od Srbije do Črne gore. Zgrajena po istem receptu, ki je naredil go2georgia uspešno.',
    outcomes: [
      'Širitev go2 pristopa na velik, premalo pokrit trg',
      'Vsebiška arhitektura za več držav za regionalno SEO prevlado',
      'AI načrtovanje itinerarjev za 10+ balkanskih držav',
    ],
    tags: ['Širitev', 'AI', 'SEO', 'Regija'],
    link: null,
  },
];

// STORITVE
export const services = [
  {
    icon: 'Search',
    number: '01',
    title: 'SEO & sistemi organske rasti',
    subtitle: 'Promet, ki narašča. Ne kampanje, ki potečejo.',
    description: 'SEO pri nas ni dodatna storitev. Gradimo celotne platforme, zasnovane za prevlado v organskem iskanju. Globoka tematska avtoriteta, tehnična odličnost in vsebinski sistemi, ki prinašajo rezultate leta — ne tedne.',
    outcomes: [
      'Trajnosten organski promet, ki raste brez oglaševalskih vložkov',
      'Tematska avtoriteta v specifičnih nišah in na trgih',
      'Vsebinski sistemi, ki skalirajo brez sorazmernega povečanja stroškov',
      'Uvrstitve na prvo stran za komercialno namerne ključne besede',
    ],
    useCases: [
      'go2georgia.com se uvršča med top 3 za 200+ ključnih besed v 8 mesecih',
      'potovanja.si prevladuje v slovenskem potovalnem iskanju organsko',
      'go2slovenia.com je zgradil avtoriteto v konkurenčni potovalni niši',
    ],
    tags: ['Tehnični SEO', 'Vsebinska strategija', 'Tematska avtoriteta', 'Gradnja povezav', 'Analitika iskanja'],
  },
  {
    icon: 'Link',
    number: '02',
    title: 'Affiliate & sistemi monetizacije',
    subtitle: 'Infrastruktura prihodkov, ne upanje na prihodke.',
    description: 'Vsaka platforma, ki jo zgradimo, ima monetizacijo vgrajeno od prvega dne. Oblikujemo affiliate ekosisteme, gradimo lijake za pridobivanje kontaktov in ustvarjamo partnerske modele, ki organski promet pretvorijo v merljive prihodke.',
    outcomes: [
      'Razpršeni prihodkovni tokovi prek več affiliate programov',
      'Konverzijsko optimizirane uporabniške poti od vsebine do transakcije',
      'Partnerski okviri s ponudniki, hoteli in storitvenimi podjetji',
      'Atribucija prihodkov in sledenje uspešnosti',
    ],
    useCases: [
      'Affiliate prihodki go2georgia.com rastejo 40 % mesec za mesec',
      'Integracije rezervacij hotelov in tur na vseh potovalnih platformah',
      'Večpartnerska affiliate arhitektura po celotnem ekosistemu',
    ],
    tags: ['Affiliate marketing', 'Pridobivanje kontaktov', 'Optimizacija prihodkov', 'Partnerski modeli', 'Konverzijski lijaki'],
  },
  {
    icon: 'Code',
    number: '03',
    title: 'Razvoj platform',
    subtitle: 'Gradimo sistem. Ne samo marketing.',
    description: 'Načrtujemo in razvijamo spletne platforme po meri, zgrajene za zmogljivost, skalabilnost in dolgoročno vrednost. Ne WordPress predloge. Ne agencijski projekti. Digitalna sredstva z resno infrastrukturo, zgrajena za upravljanje in rast.',
    outcomes: [
      'Platforme po meri, optimizirane za hitrost, SEO in uporabniško izkušnjo',
      'Skalabilna arhitektura, ki prenese rast brez težav',
      'Sistemi za upravljanje vsebin, zgrajeni za uredniške ekipe',
      'Večjezična in večtržna zmogljivost od začetka',
    ],
    useCases: [
      'go2georgia.com — celovita platforma z AI integracijo',
      'Večplatformski ekosistem, ki deli infrastrukturo in podatke',
      'CMS po meri, ki poganja 5 aktivnih platform hkrati',
    ],
    tags: ['Spletni razvoj', 'Platforme po meri', 'CMS', 'Zmogljivost', 'Skalabilna arhitektura'],
  },
  {
    icon: 'Brain',
    number: '04',
    title: 'Integracija umetne inteligence',
    subtitle: 'AI, ki dela. Ne AI zaradi AI-ja.',
    description: 'Umetno inteligenco integriramo tam, kjer ustvarja resnično vrednost — avtomatizacija vsebin, personalizacija uporabniških izkušenj in gradnja orodij, ki naše platforme naredijo pametnejše. Naš AI potovalni pomočnik je dokaz, da deluje.',
    outcomes: [
      'AI orodja, ki jih uporabniki resnično uporabljajo in se vračajo',
      'Avtomatizirani procesi ustvarjanja in optimizacije vsebin',
      'Personalizirana priporočila, ki povečajo angažiranost',
      'Znižani operativni stroški prek inteligentne avtomatizacije',
    ],
    useCases: [
      'AI načrtovalnik potovanj go2georgia.com — personalizirani itinerarji v sekundah',
      'AI podprto ustvarjanje vsebin po celotni mreži platform',
      'Načrtovano: razširitev AI potovalnega pomočnika na go2balkans.com',
    ],
    tags: ['AI orodja', 'Avtomatizacija', 'Personalizacija', 'Strojno učenje', 'Vsebinski AI'],
  },
];

// ZMOGLJIVOSTI (za hitri pregled na domači strani)
export const capabilities = [
  {
    icon: 'Search',
    title: 'SEO & organska rast',
    number: '01',
    description: 'Načrtujemo vidnost v iskalnikih na sistemski ravni. Naše platforme se uvrščajo za tisoče ključnih besed in ustvarjajo konstanten organski promet.',
    tags: ['Tehnični SEO', 'Vsebinska strategija', 'Tematska avtoriteta'],
  },
  {
    icon: 'Link',
    title: 'Affiliate & monetizacija',
    number: '02',
    description: 'Vsaka platforma, ki jo zgradimo, ima vgrajeno monetizacijo. Oblikujemo affiliate ekosisteme in lijake, ki promet pretvorijo v prihodek.',
    tags: ['Affiliate marketing', 'Pridobivanje kontaktov', 'Optimizacija prihodkov'],
  },
  {
    icon: 'Code',
    title: 'Razvoj platform',
    number: '03',
    description: 'Platforme po meri, vsebinski sistemi in skalabilne spletne rešitve, zasnovane za dolgoročno rast — ne kratkoročne kampanje.',
    tags: ['Spletni razvoj', 'CMS po meri', 'Zmogljivost'],
  },
  {
    icon: 'Brain',
    title: 'Integracija AI',
    number: '04',
    description: 'V naše platforme vgrajujemo AI za avtomatizacijo vsebin, personalizacijo izkušenj in gradnjo orodij z resnično vrednostjo.',
    tags: ['AI orodja', 'Avtomatizacija', 'Personalizacija'],
  },
];

// EKIPA
export const teamMembers = [
  { name: 'Matevz R.', role: 'Ustanovitelj & direktor', focus: 'VIZIJA & STRATEGIJA PLATFORM', email: 'matevz' },
  { name: 'Ana K.', role: 'Vodja SEO', focus: 'ORGANSKA RAST & VSEBINA', email: 'ana' },
  { name: 'Luka P.', role: 'Vodilni razvijalec', focus: 'ARHITEKTURA PLATFORM', email: 'luka' },
  { name: 'Nina S.', role: 'Vsebinska strateginja', focus: 'UREDNIŠTVO & OBJAVE', email: 'nina' },
];

// O NAS
export const aboutContent = {
  positioning: 'go2digital ni klasična agencija. Gradimo, upravljamo in vodimo digitalne platforme, ki generirajo promet in prihodke. Naše stranke so naši lastni produkti — in včasih partnerji, ki želijo enake rezultate.',
  story: [
    'go2digital je nastal z enostavno tezo: namesto da gradimo spletne strani za druge, zgradimo platforme, ki jih imamo v lasti. Nadzoruj promet. Nadzoruj prihodke. Nadzoruj rezultat.',
    'Kar se je začelo kot en sam potovalni blog, je preraslo v ekosistem petih aktivnih platform na več trgih in v več jezikih. SEO smo se naučili ne iz tečajev — ampak z uvrščanjem lastnih strani v konkurenčnih nišah.',
    'Med potjo smo razvili strokovnost na področju affiliate monetizacije, arhitekture platform in integracije AI. Ne zato, ker je bilo moderno, ampak ker so to naše platforme zahtevale.',
    'Danes go2digital deluje iz Slovenije z majhno ekipo in osredotočeno poslanstvo: graditi digitalna sredstva, ki ustvarjajo resnično, merljivo vrednost. Vsaka platforma v našem ekosistemu je dokaz te poslanstva.',
  ],
  philosophy: {
    title: 'Graditelj, ne ponudnik storitev.',
    points: [
      { label: 'Jemo svojo hrano', description: 'Vsako strategijo, ki jo uporabimo, najprej preizkusimo na lastnih platformah. Če ne deluje za nas, je ne prodajamo.' },
      { label: 'Platforme pred projekti', description: 'Razmišljamo v smislu sredstev, ne rezultatov. Spletna stran ni projekt — je stroj, ki mora ustvarjati vrednost leta.' },
      { label: 'Prihodek je metrika', description: 'Promet brez prihodkov je nečimrnost. Vsaka platforma, ki jo zgradimo, je zasnovana za ustvarjanje denarja — prek affiliate programov, partnerstev ali neposredne monetizacije.' },
      { label: 'AI je orodje, ne trik', description: 'AI integriramo tam, kjer ustvarja merljivo vrednost. Naš potovalni AI pomočnik ni demo — je produkt, ki ga ljudje uporabljajo.' },
    ],
  },
  advantages: [
    'Upravljamo lastne platforme — vemo, kaj deluje, ker to živimo vsak dan',
    'Naše SEO znanje je preizkušeno v boju na več trgih in v več jezikih',
    'Za prihodke gradimo od prvega dne, ne kot naknadni dodatek',
    'Naša AI integracija je praktična in produkcijska, ne eksperimentalna',
    'Razmišljamo kot lastniki, ne kot ponudniki — ker smo lastniki',
  ],
};

// STATISTIKE
export const philosophyStats = [
  { value: '5', label: 'Aktivnih platform' },
  { value: '500K+', label: 'Organskih obiskov/mesec' },
  { value: '3', label: 'Aktivni trgi' },
];

// KONTAKT
export const contactCards = [
  { icon: 'Clock', label: 'RAZPOLOŽLJIVOST', value: 'Odprti za partnerje', sub: 'Q3 2025' },
  { icon: 'MapPin', label: 'LOKACIJA', value: 'Slovenija / Na daljavo', sub: 'CET / Globalno' },
  { icon: 'Zap', label: 'ODZIVNI ČAS', value: '< 24 ur', sub: '' },
];

// UI LABELS
export const ui = {
  // Navbar
  seeOurWork: 'NAŠE DELO',
  // Hero
  statusBadge: 'Graditelj platform — Aktiven',
  seeOurPlatforms: 'Naše platforme',
  howWeThink: 'Kako razmišljamo',
  scroll: 'Pomik navzdol',
  // What We Do
  whatWeDoLabel: 'Kaj delamo',
  buildOperateScale: ['Gradimo.', 'Upravljamo.', 'Skaliramo.'],
  whatWeDoDescription: 'Ne vodimo kampanj. Gradimo digitalne platforme, zasnovane za organsko rast, affiliate monetizacijo in dolgoročno vrednost. Vsaka platforma je sredstvo, ki ga imamo v lasti in upravljamo.',
  exploreAllServices: 'Razišči vse storitve',
  // Projects Preview
  ourPlatformsLabel: 'Naše platforme :: Dokaz izvedbe',
  weBuildTitle: ['Zgradimo, ', 'kar zagovarjamo'],
  projectsDescription: 'To niso projekti za stranke. To so platforme, ki jih imamo v lasti, upravljamo in rastimo. Resnični prihodki. Resničen promet. Resničen dokaz.',
  monthlyVisits: 'Mesečnih obiskov',
  livePlatforms: 'Aktivnih platform',
  viewAllPlatforms: 'Poglej vse platforme',
  visit: 'Obišči',
  // CTA
  contactLabel: 'Kontakt',
  letsBuild: 'Zgradimo nekaj skupaj',
  gotPlatformIdea: ['Imate ', 'idejo za platformo?'],
  ctaDescription: 'Če želite partnerstvo pri digitalni platformi, raziskati affiliate priložnosti ali se pogovoriti o našem pristopu do SEO in AI — vas poslušamo.',
  startConversation: 'Začnite pogovor',
  sendMessage: 'Pošlji sporočilo',
  emailDirectly: 'E-pošta neposredno:',
  interestedInApproach: 'Vas zanima naš pristop?',
  learnHowWeThink: 'Kako razmišljamo',
  // Footer
  copyright: '© 2025 Go2 Digital. Slovenija.',
  // About
  aboutLabel: 'O nas',
  aboutHeroTitle: ['Nismo agencija.', 'Graditelji platform.'],
  ourStoryLabel: 'Naša zgodba',
  fromBlogToEcosystem: ['Od bloga do ', 'ekosistema.'],
  corePhilosophyLabel: 'Filozofija',
  whyDifferentLabel: 'Zakaj smo drugačni',
  weThinkLikeOwners: ['Razmišljamo kot ', 'lastniki.'],
  whyDifferentDesc: 'Ker smo. Vsaka strategija, vsak sistem, vsaka odločitev je najprej preizkušena na naših lastnih platformah.',
  theTeamLabel: 'Ekipa',
  smallTeamBigOutput: ['Majhna ekipa. ', 'Velik rezultat.'],
  seeWhatWeBuilt: ['Poglejte, kaj smo ', 'zgradili.'],
  viewPlatforms: 'Poglej platforme',
  // Services
  servicesLabel: 'Storitve',
  whatWeActuallyDo: ['Kaj v resnici ', 'delamo.'],
  servicesDescription: 'Štiri medsebojno povezane discipline. Vsako preizkušeno in izpopolnjeno na naših lastnih platformah, preden o njej sploh govorimo. Ne teorija. Praksa.',
  outcomes: 'Rezultati',
  realWorldProof: 'Dokazi iz prakse',
  wantToSeeInAction: ['Želite videti te sisteme ', 'v akciji?'],
  servicesCtaDesc: 'Vsaka storitev, ki jo ponujamo, je preizkušena na naših lastnih platformah. Preverite rezultate.',
  contactUs: 'Kontaktirajte nas',
  // Projects page
  projectsLabel: 'Projekti :: Dokaz izvedbe',
  ourPlatformsTitle: ['Naše ', 'platforme.'],
  projectsPageDesc: 'To niso projekti za stranke ali portfeljski kosi. To so platforme, ki smo jih zgradili, jih imamo v lasti in upravljamo. Resničen promet. Resnični prihodki. Resničen dokaz, da naš pristop deluje.',
  markets: 'Trgi',
  keyResults: 'Ključni rezultati',
  ecosystemLabel: 'Ekosistem Go2',
  onePlaybook: ['En recept. ', 'Več trgov.'],
  ecosystemDesc: 'Vsaka platforma v našem ekosistemu deli isto infrastrukturo, isto SEO metodologijo in isti okvir monetizacije. Kar deluje na eni platformi, razširimo na vse.',
  seeHowWeDoIt: 'Kako to delamo',
  inDevelopment: 'V razvoju',
};
